export default __webpack_public_path__ + "static/media/logo-gimba.cbdaab28.jpg";